import { SavingsAndInvestmentsIncomeConfig, SavingsAndInvestmentsIncomeInput, SavingsAndInvestmentsIncomeOutput } from "./interfaces";

export class SavingsAndInvestmentsIncome {

    private config: SavingsAndInvestmentsIncomeConfig;
    private input: SavingsAndInvestmentsIncomeInput;

    constructor(config: SavingsAndInvestmentsIncomeConfig, input: SavingsAndInvestmentsIncomeInput) {
        this.config = config;
        this.input = input;
    }

    calculate(): SavingsAndInvestmentsIncomeOutput {
        const belastbaarRendement = this.belastbaarRendement();
        const heffingsVrijVermogen = this.heffingsVrijVermogen();
        const aftrekbareSchulden = this.aftrekbareSchulden();
        const rendementsGrondslag = this.rendementsGrondslag(aftrekbareSchulden);
        const grondslagSparenEnBeleggen = this.grondslagSparenEnBeleggen(rendementsGrondslag, heffingsVrijVermogen);
        const aandeelRendementsGrondslag = rendementsGrondslag
            ? parseFloat((grondslagSparenEnBeleggen / rendementsGrondslag).toFixed(4))
            : 0;

        return {
            belastbaarRendement,
            rendementsGrondslag,
            aftrekbareSchulden,
            grondslagSparenEnBeleggen,
            aandeelRendementsGrondslag,
            heffingsVrijVermogen,
            voordeelSparenEnBeleggen: Math.floor(belastbaarRendement * aandeelRendementsGrondslag)
        };
    }

    private belastbaarRendement(): number {
        return Math.floor(
            (this.input.bankTegoed * (this.config.rendementBankTegoed/100))
            + (this.input.beleggingen * (this.config.rendementBeleggingen/100))
            - (this.input.schulden * (this.config.rendementSchulden/100))
        );
    }

    private aftrekbareSchulden(): number {
        const drempel = this.input.fiscaalPartner ? 2 * this.config.schuldenDrempel : this.config.schuldenDrempel;
        return Math.max(this.input.schulden - drempel, 0);
    }

    private rendementsGrondslag(aftrekbareSchulden: number): number {
        return Math.max(this.input.bankTegoed + this.input.beleggingen - aftrekbareSchulden, 0);
    }

    private heffingsVrijVermogen(): number {
        return this.input.fiscaalPartner ? 2 * this.config.heffingsVrijVermogen : this.config.heffingsVrijVermogen;
    }

    private grondslagSparenEnBeleggen(
        rendementsGrondslag: number,
        heffingsVrijVermogen: number
    ): number {
        return Math.max(rendementsGrondslag - heffingsVrijVermogen, 0);
    }

}
